import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { createCrud } from 'wm-standard-crud';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux"
import { store, persistor } from "redux/store"
import { PersistGate } from 'redux-persist/integration/react'
import { getUserToken } from 'services/helper';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

let aux = document.getElementsByClassName('base-url')[0].innerText;
const baseUrl = aux.substring(1, aux.length - 1);

createCrud(
  process.env.NODE_ENV === 'development' ? 'https://api.san-dev.watermelontecnologia.com' : baseUrl,
  () => getUserToken()
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
